import type { FC, ReactNode } from 'react';

import { LoadingIndicator } from '@motorway/mw-highway-code/alpha';

import styles from './ModalLoading.module.scss';

interface ModalLoadingProps {
	description: ReactNode;
	title: ReactNode;
}

export const ModalLoading: FC<ModalLoadingProps> = ({ description, title }) => {
	return (
		<div className={styles.container}>
			<LoadingIndicator data-thc-loading size="large" variant="arrow" />
			<div className={styles.message}>
				<span className={styles.title}>{title}</span>
				<span>{description}</span>
			</div>
		</div>
	);
};
